import * as React from 'react';
import { CheckboxList } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { FilterCommonProps, FilterCommonValues } from './types';
import { MeatballPanel } from 'app/area/search-filters/filters/meatball-panel';

export class FilterCheckbox extends React.PureComponent<FilterCommonProps<number>> {

  private onChange = (values: FilterCommonValues<number>[]) => {
    this.props.onChange(this.props.id, values);
  }

  public render() {

    const { id, values, options, meatballPanelConfiguration } = this.props;

    return <>
      <MeatballPanel configuration={meatballPanelConfiguration} />
      <CheckboxList
        className={undefined}
        componentId={id}
        valueItems={(values || []) as ComplexValue<number>[]}
        options={options as ComplexValue<number>[]}
        onChange={this.onChange}
      />
    </>;
  }
}
